<template>
    <div class="home-box">
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card>
            <v-card-title dark>
                <h3 class="ma-2">Contribution Activity Reports Zone Wise (Month 06 to 11)</h3>
                <v-spacer></v-spacer>
                <AutocompleteIdSearch @changeData="zoneId = $event" :storeLink="'member/getAllZones'" :setectVale="zoneId"
                    :itemText="'name'" :label="'Select Zone'" />
                <v-spacer></v-spacer>
                <v-btn @click="loadTaskList()" :disabled="loading || !zoneId">Download</v-btn>

            </v-card-title>

        </v-card>

    </div>
</template>

<script>
import { ActivityService } from "@/services/activity-service";
import { checkError } from "@/config/errors.js";
import AutocompleteIdSearch from "@/components/shared/AutocompleteIdSearch";
import { fileService } from "@/config/file-service.js";

export default {
    name: "ContributionZoneWiseReport",
    components: { AutocompleteIdSearch },

    data: function () {
        return {
            loading: false,
            filterBtnTTip: false,
            list: [],
            zoneId: null,
            role: localStorage.getItem("role"),
            errors: null,
            successMsg: "",
            snackbar: false,
        };
    },

    mounted() {
        this.$store.dispatch("auth/getProfile");
        
    },

    watch: {
        zoneId(val) {
           this.zoneId = val;
        }
    },

    methods: {
        loadTaskList() {
            if (this.zoneId) {
                this.loading = true;
                ActivityService.getActivityContributionZoneReport(this.zoneId, {
                    responseType: "blob",
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data) {
                            this.list = response.data;
                            this.loading = false;
                            let fileType = response.headers["content-type"];
                            let extension = "csv";
                            fileService.downloadFile(
                                response.data,
                                fileType,
                                extension,
                                "contribution-activity-" + this.zoneId
                            );
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                        this.list = [];
                    });
            }

        }


    },
};
</script>
